module.exports = __webpack_public_path__ + "static/media/ic-play.b5a0af02.svg";